export var ConversationElementType;
(function (ConversationElementType) {
    ConversationElementType["MESSAGE"] = "Message";
    ConversationElementType["QUESTION"] = "Question";
    ConversationElementType["ERROR"] = "Error";
})(ConversationElementType || (ConversationElementType = {}));
export var ConversationUiType;
(function (ConversationUiType) {
    ConversationUiType["RADIO"] = "Radio";
    ConversationUiType["BUTTON"] = "Button";
    ConversationUiType["DATEPICKER"] = "DatePicker";
    ConversationUiType["UPLOADER"] = "Uploader";
    ConversationUiType["TEXT"] = "Text";
    ConversationUiType["NUMERIC"] = "Numeric";
    ConversationUiType["TIMEPICKER"] = "TimePicker";
})(ConversationUiType || (ConversationUiType = {}));
export var ConversationAnswerDataType;
(function (ConversationAnswerDataType) {
    ConversationAnswerDataType["FILE"] = "File";
    ConversationAnswerDataType["DATE"] = "Date";
    ConversationAnswerDataType["TIME"] = "Time";
    ConversationAnswerDataType["STRING"] = "String";
    ConversationAnswerDataType["DECIMAL"] = "Decimal";
    ConversationAnswerDataType["INTEGER"] = "Integer";
    ConversationAnswerDataType["DATETIME"] = "DateTime";
    ConversationAnswerDataType["BOOLEAN"] = "Boolean";
    ConversationAnswerDataType["NULLABLEDECIMAL"] = "NullableDecimal";
    ConversationAnswerDataType["NULLABLEBOOLEAN"] = "NullableBoolean";
    ConversationAnswerDataType["NULLABLEINTEGER"] = "NullableInteger";
})(ConversationAnswerDataType || (ConversationAnswerDataType = {}));
export function getConversationElementText(texts, lang) {
    const result = texts.find(({ languageKey }) => lang === languageKey);
    return result?.value || false;
}
